import { useLocation } from "react-router-dom";
import { Groups } from "@mui/icons-material";
import DrawerButton from "./DrawerButton";

const UIText = {
  "es-CL": { label: "Teams" },
  "en-US": { label: "Teams" },
};

const Teams = () => {
  const location = useLocation().pathname.split("/")[2];
  const selected = location === "teams";
  const navTo = "/dashboard/teams";
  const accentColor = selected ? "select.accent" : "primary.light";
  const icon = <Groups {...{ sx: { color: accentColor } }} />;

  return <DrawerButton {...{ UIText, selected, navTo, icon, accentColor }} />;
};

export default Teams;
